import React from "react"
import { useNavigate } from "react-router-dom"
import { appRoutes } from "../../routes/appRoutes"
import IconFont from "../elements/IconFont"

type AccessDeniedProps = {
  title?: string
  message?: string
}

const AccessDenied: React.FC<AccessDeniedProps> = ({
  title = "You don't have permission to view this page",
  message = "This area is managed by workspace admins. Ask an admin if you need access.",
}) => {
  const navigate = useNavigate()

  return (
    <div className="flex min-h-[calc(100vh-96px)] items-center justify-center bg-background-surface-01 px-[24px]">
      <div className="flex w-full max-w-[420px] flex-col items-center text-center">
        <div className="mb-[16px] flex h-8 w-8 items-center justify-center rounded-[8px] bg-background-error text-light">
          <IconFont name="triangle-alert" size={16} className="text-light" />
        </div>
        <p className="text-sm font-medium text-body-muted">Access Denied</p>
        <p className="mt-[4px] type-heading-sm text-heading">{title}</p>
        <p className="mt-[8px] text-sm text-body-muted">{message}</p>
        <button
          type="button"
          className="btn-secondary mt-[16px] w-full"
          onClick={() => navigate(appRoutes.experiments.root, { replace: true })}
        >
          Go to Dashboard
        </button>
      </div>
    </div>
  )
}

export default AccessDenied
